import React from 'react';
import classNames from 'classnames';
import { Colors } from '@lib/enums/colors';
import styles from './ChipIconCircle.module.scss';

export default function ChipIconCircle({
  color,
  size = 16,
  dashed,
}: {
  color: Colors;
  size?: number;
  dashed?: boolean;
}) {
  return (
    <div
      className={classNames(styles.root, styles[color], {
        [styles.dashed]: dashed,
      })}
      style={{ width: size, height: size }}
    />
  );
}
